import type { ReactNode } from 'react'
import { cn } from '@/shared/ui/cn'

export type RegisterStepCardProps = {
  children: ReactNode
  className?: string
}

export function RegisterStepCard({ children, className }: RegisterStepCardProps) {
  return (
    <section className={cn('rounded-xl border bg-card p-8 shadow-sm sm:p-10', className)}>
      {children}
    </section>
  )
}
